



















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { CustomerListDto } from "@/api/customerManage";
import { Action, Getter } from "vuex-class";
import { isPermitEnterShop } from "@/api/shoppingMall";
import Clipboard from 'clipboard'

@Component({
  name: 'ClientCard'
})
export default class ClientCard extends Vue {
  @Prop({ default: () => ({}) }) data!: CustomerListDto
  @Prop({ default:'' }) action!: string
  @Action setProviderId!: (val: string) => void;

  /**
   * 打开详情页
   * @param e
   * @param id 关联id
   * @param merchantsId 客户编号
   */
  toDetail (id: string, merchantsId: string) {
    if(!this.$isAction(this.action))return false
    this.$router.push({
      path: '/clientDetail',
      query: {
        relationId: id,
        merchantsId: merchantsId
      }
    })
  }

  /**
  * @description: 折叠板展开收起事件
  * @param {*} isOpen
  * @return {*}
  */
  onToggle (isOpen) {
    this.$set(this.data, 'isOpen', !isOpen);
    (this.$refs.collapseItem as any).toggle(!isOpen)
  }

  /**
   * @description: 监听复制
   * @param {*} e 复制内容
   * @return {*}
   */
  copyCode (key) {
    let clipboard = new Clipboard('.copy', {
      text: trigger => key
    })
    clipboard.on('success', e => {
      this.$toast('复制成功')
    })
    clipboard.on('error', e => {
      this.$toast('该浏览器不支持复制')
      e.clearSelection()
    })
  }
}
